
<router-outlet></router-outlet>
@if (show) {
  <div class="PopUpContainer">
    <div class="PopUp">
      <mat-spinner style="margin:0 auto;"></mat-spinner>
      <div class="PopupProgress">{{message}}</div>
    </div>
  </div>
}
@if (cs.canshowpasscodepopup && !cs.IsLoginPage) {
  <div class="toast-container">
    <br />
    <div class="alert alert-primary-custom">
      <div class="icon-style">
        <i class="icon-Alert evenspace-icon"></i>
        <div>
          @if (cs.isCreateMessage) {
            <span>{{'passcodeconfig.createpintext' | translate}}</span>
          }
          @if (!cs.isCreateMessage) {
            <span>{{'passcodeconfig.offlinepassexpirytext1' | translate}} {{cs.expiryDays}} {{'passcodeconfig.offlinepassexpirytext2' | translate}}</span>
          }
          <div class="popup-btns">
            <button mat-button class="add-btn" (click)="later()">{{'passcodeconfig.later' | translate}}</button>
            <button mat-button class="add-btn" (click)="create()">{{cs.isCreateMessage ? "CREATE" : "RESET NOW"}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
<div id="app-toast">
  <app-toast-message [show]='toastShow' [message]="toastMessage" (AutoDismiss)='toastAutoDismiss($event)'></app-toast-message>
</div>
